import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

/**
 * Fetch + manage the broadcast history (scheduled + sent + failed).
 * Exposes a `refresh` callback so the broadcast form can ping it after
 * creating a new broadcast.
 */
export function useAdminBroadcastHistory({ enabled, limit = 50 }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cancellingId, setCancellingId] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${API}/notifications/broadcasts?limit=${limit}`,
        { withCredentials: true }
      );
      setItems(res.data?.items || []);
    } catch (err) {
      if (err.response?.status !== 403) {
        console.error('broadcasts list failed', err);
      }
    } finally {
      setLoading(false);
    }
  }, [limit]);

  useEffect(() => {
    if (enabled) refresh();
  }, [enabled, refresh]);

  const cancel = useCallback(
    async (broadcastId) => {
      setCancellingId(broadcastId);
      try {
        await axios.delete(`${API}/notifications/broadcasts/${broadcastId}`, {
          withCredentials: true,
        });
        toast.success('Broadcast cancelled');
        await refresh();
      } catch (err) {
        const detail = err.response?.data?.detail || err.message;
        toast.error(`Cancel failed: ${detail}`);
      } finally {
        setCancellingId(null);
      }
    },
    [refresh]
  );

  return { items, loading, cancellingId, refresh, cancel };
}
